import { Component, OnInit, ChangeDetectionStrategy, Input, ViewChild, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { E5ConfigurationService as e5Config } from 'e5core-angular-services';
import { WorkItemModel } from '../../models/work-item';
import { E5coreUiSelectFromListMaterialComponent } from './component/e5core-ui-select-from-list-material.component';
import { KeyValuePair } from '../../util/key-value-pair';
import { UiStyleService } from '../../services/ui-style.service';
import { DataSourceOptions } from '../../datasource/data-source-options';
import { DataSourceQuery } from '../../datasource/data-source-query';
import { DocumentDataSourceService } from '../../datasource/document-data-source.service';
import { FieldDefinitionModel } from '../../models/field-definition.model';
import { ViewerDisplayEvent } from '../../events/viewer-display-event';

@Component({
  selector: 'e5core-ui-select-from-list',
  template: `
  <span *ngIf="workItem$" [ngSwitch]="style.current()">
    <e5core-ui-select-from-list-material *ngSwitchCase='2' [datasource]='datasource' [pagesizes]="pagesizes"  [query]='query' [autoSearch]='autoSearch' (listItemViewEvent)='onListItemViewEvent($event)' (listItemSelectEvent)='onListItemSelectEvent($event)' (searchEvent)='onSearchEvent($event)'></e5core-ui-select-from-list-material>
  </span>
  <div *ngIf="!(workItem$)" class="e5core-component-error">&lt;e5core-ui-select-from-list&gt; [workItem$] must have a BehaviorSubject&lt;WorkItemModel&gt;</div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  //changeDetection: ChangeDetectionStrategy.OnPush
  providers: [
    DocumentDataSourceService
  ]
})
export class E5coreUiSelectFromListComponent  implements AfterViewInit, OnInit {

  @Input() workItem$ : BehaviorSubject<WorkItemModel>;
  @Input() libraryId : number;
  @Input() folderName : string = "";
  @Input() fieldsToShow : FieldDefinitionModel[] = null;    //Refer to http://blog.softartisans.com/2009/12/08/list-of-internal-names-for-sharepoint-fields
  @Input() includeSelect : boolean = true;
  @Input() query : DataSourceQuery = null;
  @Input() pagesizes : number[] = [5, 10, 25, 50];
  @Input() autoSearch : boolean = true;
  @Input() readonly : boolean = false;
  
  @Output() listItemViewEvent = new EventEmitter<ViewerDisplayEvent>();
  @Output() listItemSelectEvent = new EventEmitter();
	@Output() searchEvent = new EventEmitter();
  workId : string ;
  searchText : string;
  
  @ViewChild(E5coreUiSelectFromListMaterialComponent)
  private selectFromListMaterialComponent: E5coreUiSelectFromListMaterialComponent;

	error: string ;

  constructor(private config: e5Config, public style:UiStyleService, public datasource: DocumentDataSourceService) {}

  ngOnInit() {
    if (typeof this.workItem$ == 'undefined') {
      console.error('e5core-ui-select-from-list [workItem$] must have a BehaviorSubject<WorkItemModel>');
      return ;
    }

    if (typeof this.workItem$ != 'undefined') {
      this.workItem$.subscribe(
        w => {
          this.updateData();
        }
      )
    }

    if (this.libraryId == null) {
      this.error = 'e5core-ui-search-results [searchDefinitionId] must be specified' ;
      console.error(this.error);
      return ;
    }
    this.datasource.setLibrary(this.libraryId, this.folderName, this.includeSelect, this.fieldsToShow, this.searchText);
    let options:DataSourceOptions = this.datasource.defaultOptions();
    this.datasource.setDefaultOptions(options);
  }
  
  ngAfterViewInit() {
  }

  refresh() {
    this.selectFromListMaterialComponent.refresh();
  }
  
  onListItemViewEvent(event) {
    this.listItemViewEvent.emit({workId: null, type: "E5SharepointAttachment", attachmentId: null, fullUrl: event.element.fullUrl, name: event.element.fullUrl});
  }
  
  onListItemSelectEvent(event) {
    this.listItemSelectEvent.emit(event);
  }

  onSearchEvent(event) {
    debugger;
    this.searchText = event;
    this.datasource.setLibrary(this.libraryId, this.folderName, this.includeSelect, this.fieldsToShow, this.searchText);
  }

  private updateData():void {
  }
}